import fetch from 'cross-fetch';
import { URL_SURVEY_API } from '../utils/constEnvVariables'
import * as fs from 'file-saver';

export const getExcel = function (surveyId, campaignId, accessToken, fileName) {
    const requestOptions = {
        method: 'GET',
        responseType: 'arrayBuffer',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    }
    const url = `${URL_SURVEY_API}/surveys/excel/download/${surveyId}&${campaignId}`
    return fetch(url, requestOptions)
        .then(response => response.blob())
        .then(function (blob) {
            fs.saveAs(blob, `${fileName}.xlsx`)
        })
        .catch(err => { throw err })
}

export const getExcelIndirect = function (surveyId, campaignId, accessToken, fileName) {
    const requestOptions = {
        method: 'GET',
        responseType: 'arrayBuffer',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    }
    const url = `${URL_SURVEY_API}/surveys/excel/download/indirect/${surveyId}&${campaignId}`
    return fetch(url, requestOptions)
        .then(response => response.blob())
        .then(function (blob) {
            fs.saveAs(blob, `${fileName}.xlsx`)
        })
        .catch(err => { throw err })
}

export const getExcelGeneric = function (surveyId, campaignId, surveyCode, accessToken, fileName) {
    const requestOptions = {
        method: 'GET',
        responseType: 'arrayBuffer',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    }
    const url = `${URL_SURVEY_API}/surveys/excel/download/genericExcel/${surveyId}&${campaignId}&${surveyCode}`
    return fetch(url, requestOptions)
        .then(response => response.blob())
        .then(function (blob) {
            fs.saveAs(blob, `${fileName}.xlsx`)
        })
        .catch(err => { throw err })
}

export const getExcelOs = function (surveyId, campaignId, surveyCode, accessToken) {
    const fileName = surveyCode.toLowerCase();
    const requestOptions = {
        method: 'GET',
        responseType: 'arrayBuffer',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    }
    const url = `${URL_SURVEY_API}/surveys/excel/download/osexcel/${surveyId}&${campaignId}&${surveyCode}`
    return fetch(url, requestOptions)
        .then(response => response.blob())
        .then(function (blob) {
            fs.saveAs(blob, `${fileName}.xlsx`)
        })
        .catch(err => { throw err })
}

export const getExcelCoo = function (surveyId, campaignId, surveyCode, accessToken, fileName) {
    const requestOptions = {
        method: 'GET',
        responseType: 'arrayBuffer',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    }
    const url = `${URL_SURVEY_API}/surveys/excel/download/cooexcel/${surveyId}&${campaignId}&${surveyCode}`
    return fetch(url, requestOptions)
        .then(response => response.blob())
        .then(function (blob) {
            fs.saveAs(blob, `${fileName}.xlsx`)
        })
        .catch(err => { throw err })
}

export const getExcelGenericParts = function (surveyId, campaignId, surveyCode, isNonDeere, accessToken, fileName) {
    const requestOptions = {
        method: 'GET',
        responseType: 'arrayBuffer',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    }
    const url = `${URL_SURVEY_API}/surveys/excel/download/genericpartsexcel/${surveyId}&${campaignId}&${surveyCode}&${isNonDeere}`
    return fetch(url, requestOptions)
        .then(response => response.blob())
        .then(function (blob) {
            fs.saveAs(blob, `${fileName}.xlsx`)
        })
        .catch(err => { throw err })
}

export const getFilledCMRTTemplate = function (assignmentId, surveyId, allParts, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext" : "surveys";
    const requestOptions =  
        isAuthMethodOkta 
        ?
        { method: 'GET', responseType: 'arrayBuffer', headers: { 'Authorization': `Bearer ${accessToken}` } }
        :
        { method: 'GET', responseType: 'arrayBuffer' };

    const url = `${URL_SURVEY_API}/${pathParam}/cm/template/${assignmentId}&${surveyId}&${allParts}`
    return fetch(url, requestOptions)
        .then(response => response.blob())
        .then(function (blob) {
            fs.saveAs(blob, `CMRT_Template.xlsx`)
        })
        .catch(err => { throw err })
}

export const getFilledEMRTTemplate = function (assignmentId, surveyId, allParts, accessToken) {
    
    const requestOptions = {
        method: 'GET',
        responseType: 'arrayBuffer',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    }
    const url = `${URL_SURVEY_API}/surveys/em/template/${assignmentId}&${surveyId}&${allParts}`
    return fetch(url, requestOptions)
        .then(response => response.blob())
        .then(function (blob) {
            fs.saveAs(blob, `EMRT_Template.xlsx`)
        })
        .catch(err => { throw err })
}

export const getExcelSubtier = function (campaignId, accessToken) {
    const requestOptions = {
        method: 'GET',
        responseType: 'arrayBuffer',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    }
    const url = `${URL_SURVEY_API}/surveys/excel/download/subtier/${campaignId}`
    return fetch(url, requestOptions)
        .then(response => response.blob())
        .then(function (blob) {
            fs.saveAs(blob, 'subtier.xlsx')
        })
        .catch(err => { throw err })
}